// src/react.tsx
import React, { createContext, useContext } from "react";
import { useMemoOne } from "use-memo-one";

// src/selectors.ts
function getFontFaces(fontState) {
  return fontState.fontFaces;
}

// src/state.ts
import { observable } from "mobx";
function createFontsState({
  fontFaces = []
} = {}) {
  return observable({
    fontFaces
  });
}

// src/react.tsx
function createBoundFontsData(options) {
  const fontsState = createFontsState(options);
  return {
    fonts: fontsState,
    getFontFaces: () => getFontFaces(fontsState)
  };
}
var FontsContext = createContext(null);
function useFonts() {
  const state = useContext(FontsContext);
  if (state === null)
    throw new Error("useFonts() called outside of FontsProvider");
  return state;
}
function useWeakFonts(options) {
  const maybeState = useContext(FontsContext);
  const state = useMemoOne(() => maybeState ?? createBoundFontsData(options), [maybeState, options == null ? void 0 : options.fontFaces]);
  return state;
}
function FontsProvider({
  children,
  options
}) {
  const fontsData = useMemoOne(() => createBoundFontsData(options), [options == null ? void 0 : options.fontFaces]);
  return /* @__PURE__ */ React.createElement(FontsContext.Provider, {
    value: fontsData
  }, children);
}
function WeakFontsProvider({
  children,
  options
}) {
  const state = useContext(FontsContext);
  if (state === null) {
    return /* @__PURE__ */ React.createElement(FontsProvider, {
      options
    }, children);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
}
export {
  FontsProvider,
  WeakFontsProvider,
  createFontsState,
  getFontFaces,
  useFonts,
  useWeakFonts
};
